import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'

import { VueAxios } from "@/utils/request"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from '@/i18n'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets
// Element UI 内部文案（分页/日期选择器/消息框按钮等）经 vue-i18n 集成，随语言切换
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });

import Antd, { version } from 'ant-design-vue'
console.log('ant-design-vue version:', version)

import Viser from 'viser-vue'
import 'ant-design-vue/dist/antd.less';  // or 'ant-design-vue/dist/antd.less'

import '@/permission' // permission control
import '@/utils/filter' // base filter
// import Print from 'vue-print-nb-jeecg'
/*import '@babel/polyfill'*/
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import renderComponent from '@/components/renderFun/renderComponent';

require('@jeecg/antd-online-mini')
require('@jeecg/antd-online-mini/dist/OnlineForm.css')
require('@/assets/less/iconfont/iconfont.css');
require('@/assets/less/iconfont/iconfont.js');

require('@/assets/less/dafont/stylesheet.css');
require('@/assets/less/common.less');
require('@/assets/less/reset.less');

// main.js 中只保留必要引入
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// 只引入 solid 风格（你用到的图标都属于 fas）
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faCube } from '@fortawesome/free-solid-svg-icons'
// 直接添加所有 fas 图标（包含 faucet、droplet、gauge-high、water）
library.add(fas)

// 注册组件
Vue.component('font-awesome-icon', FontAwesomeIcon)

import SvgIcon from './components/SvgIcon.vue'
Vue.component('svg-icon', SvgIcon)

import {
  ACCESS_TOKEN,
  DEFAULT_COLOR,
  DEFAULT_THEME,
  DEFAULT_LAYOUT_MODE,
  DEFAULT_COLOR_WEAK,
  SIDEBAR_TYPE,
  DEFAULT_FIXED_HEADER,
  DEFAULT_FIXED_HEADER_HIDDEN,
  DEFAULT_FIXED_SIDEMENU,
  DEFAULT_CONTENT_WIDTH_TYPE,
  DEFAULT_MULTI_PAGE
} from "@/store/mutation-types"
import config from '@/defaultSettings'

import JDictSelectTag from './components/dict/index.js'
import hasPermission from '@/utils/hasPermission'
import vueBus from '@/utils/vueBus';
import JeecgComponents from '@/components/jeecg/index'
import '@/assets/less/JAreaLinkage.less'
import VueAreaLinkage from 'vue-area-linkage'
import '@/components/jeecg/JVxeTable/install'
import '@/components/JVxeCells/install'
// 20201228引入公用组件components(echart)
import '@/utils/components/components';
import Print from 'vue-print-nb';

//20220228引入element中tree组件
import { Tree } from 'element-ui';

import renderElementComponent from '@/components/elementUIRender.js';

//注册地图
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: 'wmmSHJX6LrP9LlYjNujXbfD2MunckDbn'
})

//
import formDesigner from '@/components/formdesigner/components/index'
import '@/components/formdesigner/assets/iconfont/iconfont.js'
import "@/plugins/package/theme/element-variables.css";
import "@/plugins/package/theme/index.css";
Vue.use(formDesigner);

Vue.prototype.imageVisible = false;
Vue.prototype.dialogImageUrl = '';
Vue.config.productionTip = false
Vue.use(Storage, config.storageOptions)
Vue.use(Antd)
Vue.use(VueAxios, router)
Vue.use(Viser)
Vue.use(hasPermission)
Vue.use(JDictSelectTag)
Vue.use(Print)
Vue.use(preview)
Vue.use(vueBus);
Vue.use(JeecgComponents);
Vue.use(VueAreaLinkage);

Vue.component(Tree.name, Tree);//或者Vue.use(Tree)


new Vue({
  router,
  store,
  i18n,
  mounted () {
    store.commit('SET_SIDEBAR_TYPE', Vue.ls.get(SIDEBAR_TYPE, true))
    store.commit('TOGGLE_THEME', Vue.ls.get(DEFAULT_THEME, config.navTheme))
    store.commit('TOGGLE_LAYOUT_MODE', Vue.ls.get(DEFAULT_LAYOUT_MODE, config.layout))
    store.commit('TOGGLE_FIXED_HEADER', Vue.ls.get(DEFAULT_FIXED_HEADER, config.fixedHeader))
    store.commit('TOGGLE_FIXED_SIDERBAR', Vue.ls.get(DEFAULT_FIXED_SIDEMENU, config.fixSiderbar))
    store.commit('TOGGLE_CONTENT_WIDTH', Vue.ls.get(DEFAULT_CONTENT_WIDTH_TYPE, config.contentWidth))
    store.commit('TOGGLE_FIXED_HEADER_HIDDEN', Vue.ls.get(DEFAULT_FIXED_HEADER_HIDDEN, config.autoHideHeader))
    store.commit('TOGGLE_WEAK', Vue.ls.get(DEFAULT_COLOR_WEAK, config.colorWeak))
    store.commit('TOGGLE_COLOR', Vue.ls.get(DEFAULT_COLOR, config.primaryColor))
    store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    store.commit('SET_MULTI_PAGE',Vue.ls.get(DEFAULT_MULTI_PAGE,config.multipage))
  },
  render: h => h(App)
}).$mount('#app')